export const blockIconsPrivacyandsecurityWifiPasswordNew = (
	<span className='material-symbols-outlined'>wifi_password</span>
);
